import { SortDirection } from '@front-app/components/dataDashboard/model';
import { DataPointName } from '@front-app/hooks/DataDashboard/model';
import { GroupDataRange, GroupDataType } from '@front-app/services/GroupsApi/GroupDataModel';

export enum GroupDataQuery {
	DATA_SOURCE = 'source',
	DATA_RANGE = 'range',
	SORT_BY = 'sort_by',
	SORT_DIRECTION = 'sort_direction',
	CATEGORY = 'category',
	GROUP = 'group',
}

export const DEFAULT_SOURCE = GroupDataType.MEMBERS;
export const DEFAULT_RANGE = GroupDataRange.LAST_30_DAYS;
export const DEFAULT_SORT_BY = DataPointName.DATE;
export const DEFAULT_SORT_DIRECTION = SortDirection.DESC;
